const loginReducer = (state = {}, action) => {
   
    switch (action.type) {
        case "IS_LOADING":
            return Object.assign({}, state, {
                isLoading: action.data,
            });
        case "IS_LOGIN":
            return Object.assign({}, state, {
                isLogin: action.data,
            });

        default:
            return state;
    }
};
export default loginReducer;